<template>
    <b-container class="py-4 text-center">
      <h2>First Video 🎥</h2>
      <h5>Read the script to see how vidon works</h5>
      <p>"Hey name. This is the magic of personalised videos with Vidon!"</p>

      <div style='width: 500px; margin: auto;'>
        <VideoRecorder :on_complete="upload_video" :max_limit="60" :uploading_progress="uploading_progress"/>
      </div>

      <b-card class="mt-4 tips-card">
        <h4>Tips</h4>
        <ul>
          <li>Read only the text above, don't add anything else</li>
          <li>Speak at a normal speed</li>
          <li>Bright room with low background noise</li>
          <li>Ensure your head is not too small, use the guide</li>
          <li>Face is clearly visible and not in shadow or covered</li>
          <li>Try not to have over exaggerated facial expressions or move head too much</li>
        </ul>
      </b-card>

      <br />
      <b-link v-if="profile.role === 'admin'" :to="{name: 'dashboard'}">Skip</b-link>
    </b-container>
</template>

<script>

import { db, storage, config, FieldValue, _firebase } from '@/main.js'
import moment from 'moment/src/moment'
import VideoRecorder from '@/components/VideoRecorder.vue'
import api from '@/lib/api.js'

function compare(str1, str2) {
  let _str1 = str1.replace(/[^\w\s]|_/g, "").replace(/\s+/g, " ").toLowerCase()
  let _str2 = str2.replace(/[^\w\s]|_/g, "").replace(/\s+/g, " ").toLowerCase()

  return _str1 === _str2
}

export default {
  metaInfo: {title: 'Onboarding video'},
  components: {VideoRecorder},
  props: ['profile', 'user'],
  data() {
    return {
      is_uploading: false,
      uploading_progress: null,
      transcript: '',
      word_time_offsets: [],
      video_url: null
    }
  },
  methods: {
    upload_progress(snapshot) {
      // Observe state change events such as progress, pause, and resume
      // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
      var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      console.log('Upload is ' + progress + '% done');
      this.uploading_progress = progress
      switch (snapshot.state) {
        case _firebase.storage.TaskState.PAUSED: // or 'paused'
          console.log('Upload is paused');
          break;
        case _firebase.storage.TaskState.RUNNING: // or 'running'
          console.log('Upload is running');
          break;
      }
    },
    async video_to_text(video_url) {
      let response = await api.video_to_text(video_url)
      return response.data
    },
    video_duration(src) {
      return new Promise((resolve, reject) => {
        try {
          let video = document.createElement('video')
          video.preload = 'metadata'

          video.onloadedmetadata = function () {
            resolve(this)
          }

          video.onerror = function () {
            reject("Invalid video. Please select a video file.")
          }

          // video.src = window.URL.createObjectURL(file)
          video.src = src
        } catch (e) {
            reject(e)
        }
      })
    },
    async upload_video(raw_data) {
      let src = window.URL.createObjectURL(raw_data)

      if (!src) {
        this.$swal({title: 'No file', text: "Please upload a video file", icon: 'warning'})
        return false
      }

      // const MAX_SIZE = 5 * 1048576 // 5 MB
      // if (this.file.size > MAX_SIZE) {
      //   this.$swal({title: 'Invalid video', text: `Please upload a video file < 5MB. Your video is ${(this.file.size / 1048576).toFixed(0)}MB`, icon: 'warning'})
      //   return false
      // }

      let video
      try {
        video = await this.video_duration(src)
      } catch (err) {
        this.$swal({title: 'Invalid video', text: "Please upload a valid MP4 video file", icon: 'warning'})
        return false
      }

      // if (video.duration > 60) {
      //   this.$swal({title: 'Invalid video', text: `Please upload a video file < 60 seconds. Your video is ${video.duration.toFixed(0)}s`, icon: 'warning'})
      //   return false
      // }

      // if (video.videoWidth > 1080 || video.videoWidth < 420 || video.heightWidth > 720 || video.heightWidth < 320) {
      //   this.$swal({title: 'Invalid video', text: `Please upload a video between 420x320 and 1080x720. Your video is ${video.videoWidth}x${video.heightWidth}`, icon: 'warning'})
      //   return false
      // }

      this.is_uploading = true
      this.uploading_progress = 0

      let snap = storage.ref().child(`${this.profile.id}/videos/${db.collection('media').doc().id}`).put(raw_data)

      snap.on('state_changed', this.upload_progress)
      snap = await snap

      let url = await snap.ref.getDownloadURL()

      let result
      try {
        result = await this.video_to_text(url)
      } catch (err) {
        console.warn(err)
        this.$swal({title: 'Failed to transcribe', text: "Please ensure the video is less than 1 minute", icon: 'warning'})
        this.is_uploading = false
        this.uploading_progress = null
        return false
      }

      this.is_uploading = false
      this.uploading_progress = null

      this.words = []
      let found_name = false
      for (let word of result.words) {
        if (compare(word, 'name')) {
          found_name = true
          break
        }
      }

      if (!found_name) {
        this.$swal({title: 'Please try again', text: "We couldn't hear the word \"name\" in your video. Please try again and say it clearly.", icon: 'warning'})
        return
      }

      let item_doc = db.collection('project').doc()
      let item = {
        created: new Date(),
        updated: new Date(),
        team: db.collection('team').doc(this.profile.team.id),
        uid: this.profile.id,
        user: db.collection('user').doc(this.profile.id),
        status: 'pending',
        quality_control: true,
        name: 'First Video',
        video_url: url,
        cards: [
          {title: 'More examples', text: 'View some more examples of your clone', link_text: 'More examples', link_url: 'https://app.vidon.ai/projects'},
          {title: 'Something not right?', text: 'Reach out to our team for help', link_text: 'Livechat', link_url: 'https://app.vidon.ai'},
          {title: 'Prospecting guide', text: 'Read our guide to get the most out of your trial', link_text: 'Learn more', link_url: 'https://support.vidon.ai/979dc1a93b304f58a13143eeb12a7bf5'}
        ],
        presentation: 'website',
        generation_type: 'face',
        fallback_video_url: null,
        thumbnail_url: null,
        variables: [{word: 'name', prefix_words: 1, suffix_words: 0, speed: 1.0}],
        cta_text: 'View more videos',
        cta_url: 'https://app.vidon.ai/projects',
        voice_doc: db.collection('voice').doc(this.profile.avatar.id),
        subscriptions: [],
        transcript: result.transcript,
        word_time_offsets: result.word_time_offsets,
        items_count: 0,
        video_player_url: `https://${config.firebase_config.video_domain}/video/?project=${encodeURIComponent(item_doc.id)}`
      }

      await item_doc.set(item)
      await db.collection('user').doc(this.profile.id).update({updated: new Date(), onboarding_step: 'voice'})
      this.$router.push({name: 'onboarding_voice'})
    },
  }
}
</script>

<style scoped>

.tips-card {
  width: 500px;
}

.main {
  background: white;
  max-width: 24em;
}

</style>
